export function mapCbPrimaryScoreName(id: string | number): string {
  return `primary_score_${id}_value`
}
